import React from 'react';
import ContextHelpTip from '../common/ContextHelpTip';

const CHAIR_SCRIPT_USAGE_HINT =
  'Suggested wording for this moment. Read it to the assembly first, then use the matching control in Active business to record the step and move on—same order at every stage.';

const ChairScript = ({ chairMessage, refining = false, source = 'template' }) => {
  const showRefining = refining;
  const showAiHint = !refining && (source === 'claude' || source === 'gateway');

  return (
    <div className="shrink-0 rounded-xl border border-pp-line/80 bg-pp-surface p-3 shadow-pp">
      <div className="flex items-center gap-1.5">
        <h2 className="text-sm font-semibold tracking-tight text-pp-ink">Chair script</h2>
        <ContextHelpTip text={CHAIR_SCRIPT_USAGE_HINT} />
        {showRefining ? (
          <span className="ml-auto text-[10px] font-medium uppercase tracking-wide text-pp-muted">
            Refining…
          </span>
        ) : showAiHint ? (
          <span className="ml-auto text-[10px] font-medium uppercase tracking-wide text-pp-muted">
            Suggested
          </span>
        ) : null}
      </div>

      <div className="mt-2 rounded-lg border-l-4 border-pp-accent bg-pp-paper/70 px-3 py-2.5">
        <p className="text-sm font-medium leading-snug text-pp-ink">
          {refining ? '' : chairMessage}
        </p>
      </div>
    </div>
  );
};

export default ChairScript;
